import {Component, Input} from '@angular/core';
import {ConsumerReport} from '../../../../_data/reports/consumer/consumer-report';
import {ConsumerRequest} from '../../../../_data/reports/consumer/consumer-request';
import {reformatDate, reformatDateTime} from 'src/app/_utils/lang';
import {getFullNameFromConsumerRequest, isCreditFreezeMessageExists, mergeSubjectIdentifiers, primaryGivenNames, primaryName} from 'src/app/_utils/consumer';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-consumer-credit-report-sidenav',
    templateUrl: './consumer-credit-report-sidenav.component.html',
    styleUrls: ['./consumer-credit-report-sidenav.component.scss'],
    imports: [TranslateModule]
})
export class ConsumerCreditReportSidenavComponent {

  @Input() consumerReport: ConsumerReport;
  @Input() consumerRequest: ConsumerRequest;

  reformatDate = reformatDate;
  primaryName = primaryName;
  primaryGivenNames = primaryGivenNames;
  mergeSubjectIdentifiers = mergeSubjectIdentifiers;
  isCreditFreezeMessageExists = isCreditFreezeMessageExists;
  getFullNameFromConsumerRequest = getFullNameFromConsumerRequest;
  constructor() { }

  getCurrentDate(): string {
    return reformatDateTime(new Date(), 'LLL');
  }
}
